import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import DefaultAvatar from "../../assets/AvatarProfile.png";
import ProfileNav from "../ProfileNav";
import axios from "axios";

const Header = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [showAccounts, setShowAccounts] = useState(false);
  const { user, loading, logout } = useUser();
  const [profile, setProfile] = useState(null);
  const handleLogout = () => {
  localStorage.removeItem("token"); // Remove token
  navigate("/"); // Redirect to home
};

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await axios.get("http://127.0.0.1:8000/profile_actions/me/", {
          headers: {
            Authorization: `Token ${token}`,
          },
        });
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    if (user) {
      fetchProfile();
    }
  }, [user]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const getPageTitle = () => {
    const path = location.pathname.split("/")[1];
    if (!path) return "Dashboard";
    return path.charAt(0).toUpperCase() + path.slice(1);
  };

  return (
    <div className="mb-8">
      <div className="flex sm:gap-2 gap-5 sm:flex-row flex-col sm:justify-between sm:items-center">
        <div className="relative w-full">
          <input
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search..."
            className="sm:w-[320px] w-full px-4 py-2 pl-10 pr-4 text-gray-700 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#19BFB7] focus:border-transparent"
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
        <div className="flex items-center sm:justify-end justify-between  gap-4 relative w-full">
          <button
            className="p-2 border border-gray-200 rounded-md cursor-pointer"
            onClick={() => navigate("/notifications")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M 11.988281 0.99023438 A 0.750075 0.750075 0 0 0 11.25 1.75 L 11.25 3.1523438 C 7.2185669 3.5496326 4.0175781 6.8479156 4.0175781 10.982422 L 4.0175781 14.082031 C 4.0175781 16.848644 2.1699219 18.71875 2.1699219 18.71875 A 0.750075 0.750075 0 0 0 2.6992188 20 L 9 20 C 9 21.648068 10.351932 23 12 23 C 13.648068 23 15 21.648068 15 20 L 21.300781 20 A 0.750075 0.750075 0 0 0 21.830078 18.71875 C 21.830078 18.71875 19.982422 16.848644 19.982422 14.082031 L 19.982422 10.982422 C 19.982422 6.8479156 16.781433 3.5496326 12.75 3.1523438 L 12.75 1.75 A 0.750075 0.750075 0 0 0 11.988281 0.99023438 z M 12 4.5 C 15.588642 4.5 18.482422 7.3928035 18.482422 10.982422 L 18.482422 14.082031 C 18.482422 16.107423 19.179375 17.513214 19.832031 18.5 L 4.1679688 18.5 C 4.8206249 17.513214 5.5175781 16.107423 5.5175781 14.082031 L 5.5175781 10.982422 C 5.5175781 7.3928035 8.411358 4.5 12 4.5 z M 10.5 20 L 13.5 20 C 13.5 20.837932 12.837932 21.5 12 21.5 C 11.162068 21.5 10.5 20.837932 10.5 20 z"></path>
            </svg>
          </button>

          {!loading && user && profile && (
            <div
              className="flex items-center gap-3 relative cursor-pointer"
              onClick={() => setShowAccounts(!showAccounts)}
            >
              <div className="relative">
           <h3 className="text-md font-semibold text-gray-900">
                  {profile.username}
                </h3>
              </div>

              <div>
                <h3 className="text-md font-semibold text-gray-900">
                  {profile.first_name} {profile.last_name}
                </h3>
                <p className="text-sm text-gray-500">{user.email}</p>
              </div>
              {showAccounts && <ProfileNav onLogout={handleLogout} candidate_type={profile.account_type} is_candidate={profile.account_type === 'candidate'}/>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;